gsap.config({ nullTargetWarn: false, trialWarn: false });
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText, TextPlugin, CSSRulePlugin);


function calculateVh() {
	var vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', vh + 'px');
	var vw = window.innerWidth * 0.01;
	document.documentElement.style.setProperty('--vw', vw + 'px');
}
calculateVh();
window.addEventListener('resize', calculateVh);
window.addEventListener('orientationchange', calculateVh);

/**
 * ScrollSmoother init
 */
ScrollTrigger.normalizeScroll(true); // enable
// create
let mm = gsap.matchMedia();
mm.add("(min-width: 1024px)", () => {
ParSmooth = 1.5;
ParEffects = true;
return () => { // optional
// custom cleanup code here (runs when it STOPS matching)
};
});
mm.add("(max-width: 1023px)", () => {
ParSmooth = 0.01;
ParEffects = false;
return () => { // optional
// custom cleanup code here (runs when it STOPS matching)
};
});


// FIXED HEADER REVEEAL ON SCROLL UP
const headerFixedInit = function (container) {
const headerAnim = gsap.from('.d-header', { 
  yPercent: -100,
  paused: true,
  duration: 0.2
}).progress(1);

ScrollTrigger.create({
  start: "top top",
  end: 99999,
  onUpdate: (self) => {
    self.direction === -1 ? headerAnim.play() : headerAnim.reverse()
  }
});
}

const smootherInit = function (container) {
let smootherdooi = ScrollSmoother.create({
smooth: ParSmooth,
effects: ParEffects,
ignoreMobileResize: true
});
}

smootherInit();

// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event) {
window.onload = function() {
window.requestAnimationFrame(function() {
calculateVh();
//smootherInit();
headerFixedInit();
viewPortSetup();
initFullMenuReveal();
initFullMenuRevealViaMenuLink();
animPageEnter();
animHeroBgrd();
animPageHeroBgrd();
initLinesRevealUp();
setupSplits();
initCharsRevealUpNoOverflow();
	

});
};
});


/**
 * Scrolltrigger logosign white
 */
const viewPortSetup = function (container) {
var tl1 = gsap.timeline();
tl1
.to('.d-header', {
duration: 0.2,
autoAlpha: 1}, 0.2)
.set('.d-home-hero-title', {autoAlpha: 1}, 0.1)
.set('.d-home-hero-subline', {autoAlpha: 1}, 0.1)
.set('.d-home-hero-services', {autoAlpha: 1}, 0.1)
.set('.d-page-hero-title', {autoAlpha: 1}, 0.1)
.set('.d-page-hero-service-group', {autoAlpha: 1}, 0.1)
;
}

/**
 * HERO SEQUENCE
 */

const animPageEnter = function () {
document.fonts.ready.then(() => {
const tlSubtitle = gsap.timeline({paused:true});
myHeroSplitText1 = new SplitText(".d-home-hero-title h1", { type: "lines" }),
myHeroSplitText2 = new SplitText(".d-home-hero-subline p", { type: "lines" }),
myHeroSplitText3 = new SplitText(".d-home-hero-services p", { type: "lines" }),
myHeroSplitText4 = new SplitText(".d-page-hero-title h1", { type: "lines" }),
myHeroSplitText5 = new SplitText(".d-page-hero-service-group p", { type: "lines" }),
chars1 = myHeroSplitText1.lines;
chars2 = myHeroSplitText2.lines;
chars3 = myHeroSplitText3.lines;
chars4 = myHeroSplitText4.lines;
chars5 = myHeroSplitText5.lines;
tlSubtitle
.from(chars1, {
autoAlpha: 0,
yPercent: 30,
duration: 0.7, // it was 1.2
ease: "expo.out",
stagger: 0.2
}, 0.2)
.from(chars2, {
autoAlpha: 0,
yPercent: -30,
duration: 0.7, // it was 1.2
ease: "expo.out",
stagger: 0.2
}, 0.2)
.from(chars3, {
autoAlpha: 0,
yPercent: 30,
duration: 0.7, // it was 1.2
ease: "expo.out",
stagger: 0.2
}, 0.6)
.from(chars4, {
autoAlpha: 0,
yPercent: 30,
duration: 0.7, // it was 1.2
ease: "expo.out",
stagger: 0.2
}, 0.2)
.from(chars5, {
autoAlpha: 0,
yPercent: 30,
duration: 0.7, // it was 1.2
ease: "expo.out",
stagger: 0.2
}, 0.6)
;
const tl = gsap.timeline({
    onComplete: () => {
      tlSubtitle.play();
    }
  });
tl
;
return tl;
	
});

}


/**
 * HERO BACKGROUND FADE-IN
 */
const animHeroBgrd = function (container) {
const element = document.querySelectorAll(".d-hero-marker");
const elementH = document.querySelectorAll(".d-hero-bgrd");
element.forEach((element) => {	
var tl1 = gsap.timeline({
scrollTrigger: {
trigger: element,
start: "bottom 97%",
end: "bottom 72%",
scrub: true
}
});
tl1
.fromTo(elementH, {
opacity: 0,
}, {
opacity: 0.25,
})
;
});
}


/**
 * HERO BACKGROUND FADE-IN
 */
const animPageHeroBgrd = function (container) {
const element = document.querySelectorAll(".d-page-hero-marker");
const elementH = document.querySelectorAll(".d-page-hero-bgrd");
element.forEach((element) => {	
var tl1 = gsap.timeline({
scrollTrigger: {
trigger: element,
start: "bottom 97%",
end: "bottom 72%",
scrub: true
}
});
tl1
.fromTo(elementH, {
opacity: 0,
}, {
opacity: 0.25,
})
;
});
}


/**
 * Scrolltrigger logosign white
 */
const XXXXX = function (container) {
const element = container.querySelectorAll(".d-logo-w");
const eleLogosignCont = document.querySelectorAll(".d-header-logosign-w");
const eleLogosignDCont = document.querySelectorAll(".d-header-logosign-c");
const eleLogosign = document.querySelectorAll(".d-header-logosign-w a");
const eleLogosignD = document.querySelectorAll(".d-header-logosign-c a");
element.forEach((element) => {	
var tl1 = gsap.timeline({
scrollTrigger: {
trigger: element,
toggleActions: "play none none reverse",
start: "top 9%",
}
});
tl1
.to(eleLogosignD, {
duration: 0.1,
autoAlpha: 0},0)
.to(eleLogosign, {
duration: 0.1,
autoAlpha: 1},0.1)
.to(eleLogosignDCont, {
duration: 0.1,
autoAlpha: 0},0)
.to(eleLogosignCont, {
duration: 0.1,
autoAlpha: 1},0.1)
;
});
};









// INNER LONG TITLE REVEAL BY WORDS
const initWordsReveal = function (container) {
gsap.utils.toArray(".rev--w").forEach(function(elem) {
const innerSplitWR = new SplitText(elem, {
type: "words"
});
const WRTimeline = gsap.timeline(
{
scrollTrigger: {
trigger: elem,
start:"top 85%",
animation: WRTimeline,
toggleActions: "play none none none",
scrub:false,
}
});
WRTimeline.from(innerSplitWR.words, {
duration: 0.35,
autoAlpha: 0,
scale: 0.8,
transformOrigin: "top left",
ease: "power4.out",
stagger: 0.05
});
});
}
// END




// INNER LONG block REVEAL BY lines from below
const initLinesRevealUp = function (container) {
document.fonts.ready.then(() => {
gsap.utils.toArray(".fade").forEach(function(elem) {
const innerSplitWR = new SplitText(elem, {
type: "lines",
});
const WRTimeline = gsap.timeline(
{
scrollTrigger: {
trigger: elem,
start:"top 85%",
animation: WRTimeline,
toggleActions: "play none none none",
scrub:false,
}
});
WRTimeline.from(innerSplitWR.lines, {
duration: 0.7,
autoAlpha: 0,
yPercent: 100,
ease: "expo.out",
stagger: 0.1
});
});
}
);
}
// END


// INNER LONG block REVEAL BY lines from below
const initCharsRevealUpNoOverflow = function (container) {
document.fonts.ready.then(() => {
gsap.utils.toArray(".rev-up-cno").forEach(function(elem) {
const innerSplitWR = new SplitText(elem, {
type: "lines",
linesClass: "split_outer"
});
const WRTimeline = gsap.timeline(
{
scrollTrigger: {
trigger: elem,
start:"top 85%",
animation: WRTimeline,
toggleActions: "play none none none",
scrub:false,
}
});
WRTimeline.from(innerSplitWR.lines, {
duration: 0.7,
yPercent: 110,
ease: "expo.out",
stagger: 0.05
});
});
}
);
}
// END



// FULL PAGE MENU REVEAL
const initFullMenuReveal = function (container) {
let overlayButton = document.querySelector("#menuOverlayButton");
let overlayButtonClose = document.querySelector("#menuOverlayButtonClose");

var tl = gsap.timeline({ paused: true });
tl
.fromTo(".d-header-full", {
    clipPath: "inset(0% 0% 100% 0%)",
}, {
  duration:1,
  clipPath: "inset(0% 0% 0% 0%)",
  ease:"expo.inOut"
}, 0)
tl.reverse();
	
overlayButton.addEventListener('click', () => {
tl.play();
});
overlayButtonClose.addEventListener('click', () => {
tl.reverse();
});
}
// end

// FULL PAGE MENU REVEAL AFTER CLICK ON THE OUR SERVICES LINK IN THE MAIN MENU
const initFullMenuRevealViaMenuLink = function (container) {
let overlayButton = document.querySelector(".d-header .d-header-nav .menuReveal a");
let overlayButtonClose = document.querySelector(".d-header-full .d-header-nav-full .menuReveal a");

var tl = gsap.timeline({ paused: true });
tl
.fromTo(".d-header-full", {
    clipPath: "inset(0% 0% 100% 0%)",
}, {
  duration:1,
  clipPath: "inset(0% 0% 0% 0%)",
  ease:"expo.inOut"
}, 0)
tl.reverse();
	
overlayButton.addEventListener('click', () => {
tl.play();
});
overlayButtonClose.addEventListener('click', () => {
tl.reverse();
});
}
// end



/**
 * Header Transitions
 */
const initHeaderTransitions = function (container) {
let mma = gsap.matchMedia();
mma.add("(min-width: 961px)", () => {
const element = container.querySelectorAll(".d-header-controler");
const eleLogoCont = document.querySelectorAll(".d-header-logo");
const eleLogosignCont = document.querySelectorAll(".d-header-logosign-c");
const eleLogo = document.querySelectorAll(".d-header-logo a");
const eleLogosign = document.querySelectorAll(".d-header-logosign-c a");
const eleNav = document.querySelectorAll(".d-header-nav");
const eleNavBtn = document.querySelectorAll(".d-header-nav-btn");
element.forEach((element) => {
const tlHeroSkew = gsap.timeline(
{
scrollTrigger: {
trigger: element,
animation:tlHeroSkew,
start: "top 9%",
toggleActions: "play none none reverse",
scrub: false
}
});
tlHeroSkew
.to(eleLogoCont, {
autoAlpha: 0,
duration: 0.1,
ease: "none"
},0)
.to(eleLogo, {
autoAlpha: 0,
duration: 0.1,
ease: "none"
},0)
.to(eleNav, {
autoAlpha: 0,
duration: 0.1,
ease: "none"
},0)
.fromTo(eleLogosignCont, {
autoAlpha: 0,
}, {
autoAlpha: 1,
duration: 0.1,
ease: "none"
},0.1)
.fromTo(eleLogosign, {
autoAlpha: 0,
}, {
autoAlpha: 1,
duration: 0.1,
ease: "none"
},0.1)
.fromTo(eleNavBtn, {
autoAlpha: 0,
}, {
autoAlpha: 1,
duration: 0.1,
ease: "none"
},0.1)
;
});
});
}


const setupSplitLines = function (container) {
document.fonts.ready.then(() => {
let mma = gsap.matchMedia();
mma.add("(min-width: 961px)", () => {

const quotes = document.querySelectorAll(".ani-l");
quotes.forEach(quote => {
quote.split = new SplitText(quote, { 
type: "lines",
linesClass: "split_outer"
});

quote.anim = gsap.from(quote.split.lines, {
scrollTrigger: {
trigger: quote,
toggleActions: "play none none none",
start: "top 85%",
},
duration: 0.7, 
ease: "power4.out", 
opacity: 0,
yPercent: 110, 
stagger: 0.08,
});
});
});
});
}


const setupSplits = function (container) {
document.fonts.ready.then(() => {
let mma = gsap.matchMedia();
mma.add("(min-width: 1024px)", () => {

const quotes = document.querySelectorAll(".ani-split");
quotes.forEach(quote => {
quote.split = new SplitText(quote, { 
type: "lines",
linesClass: "split_outer"
});

quote.anim = gsap.from(quote.split.lines, {
scrollTrigger: {
trigger: quote,
toggleActions: "play none none none",
start: "top 85%",
},
duration: 0.7, 
ease: "power4.out", 
yPercent: 110, 
stagger: 0.1,
});
});
});
});
}

const setupSplitsSlow = function (container) {
document.fonts.ready.then(() => {
let mma = gsap.matchMedia();
mma.add("(min-width: 961px)", () => {

const quotes = document.querySelectorAll(".ani-split-s");
quotes.forEach(quote => {
quote.split = new SplitText(quote, { 
type: "lines, chars",
linesClass: "split_outer"
});

quote.anim = gsap.from(quote.split.chars, {
scrollTrigger: {
trigger: quote,
toggleActions: "play none none none",
start: "top 80%",
},
duration: 0.7, 
ease: "power4.out", 
yPercent: 110, 
stagger: 0.04,
});
});
});
});
}

const setupSplitsSlowReverse = function (container) {
document.fonts.ready.then(() => {
let mma = gsap.matchMedia();
mma.add("(min-width: 961px)", () => {

const quotes = document.querySelectorAll(".ani-split-s-r");
quotes.forEach(quote => {
quote.split = new SplitText(quote, { 
type: "lines, chars",
linesClass: "split_outer"
});

quote.anim = gsap.from(quote.split.chars, {
scrollTrigger: {
trigger: quote,
toggleActions: "play none none none",
start: "top 80%",
},
duration: 0.7, 
ease: "power4.out", 
yPercent: -110, 
stagger: 0.04,
});
});
});
});
}



/**
 * Scrolltrigger logosign red
 */
const animKnowHow = function (container) {
const element = container.querySelectorAll(".ani-khho");
const elementbg1 = container.querySelectorAll(".d-type-13-bg-1-c");
const elementbg2 = container.querySelectorAll(".d-type-13-bg-2-c");
const elementbg3 = container.querySelectorAll(".d-type-13-bg-3-c");
const elementbg4 = container.querySelectorAll(".d-type-13-1");
const elementbg5 = container.querySelectorAll(".d-type-13-2");

element.forEach((element) => {	
var tl1 = gsap.timeline({
scrollTrigger: {
trigger: element,
toggleActions: "play none none none",
start: "top 85%",
}
});
tl1
.fromTo(elementbg1, {
scale: 1.5,
clipPath: "inset(33.333% 0% 66.667% 0%)",
}, {
scale: 1,
clipPath: "inset(0% 0% 66.667% 0%)",
duration: 1.4,
ease: "expo.out"
},0)
.fromTo(elementbg4, {
clipPath: "inset(100% 0% 0% 0%)",
}, {
clipPath: "inset(0% 0% 0% 0%)",
duration: 0.8,
ease: "expo.out"
},0)
.fromTo(elementbg2, {
scale: 1.5,
clipPath: "inset(66.667% 0% 33.333% 0%)",
}, {
scale: 1,
clipPath: "inset(33.333% 0% 33.333% 0%)",
duration: 1.4,
ease: "expo.out"
},0.15)
.fromTo(elementbg5, {
clipPath: "inset(0% 0% 100% 0%)",
}, {
clipPath: "inset(0% 0% 0% 0%)",
duration: 0.8,
ease: "expo.out"
},0.35)
.fromTo(elementbg3, {
scale: 1.5,
clipPath: "inset(100% 0% 0% 0%)",
}, {
scale: 1,
clipPath: "inset(66.667% 0% 0% 0%)",
duration: 1.4,
ease: "expo.out"
},0.3)
;
});
};





/**
 * Featured Service horizontal skew
 */
const animSkewFBTitle = function (container) {
const element = container.querySelectorAll(".d-feat-scrub-t");
const elementH = container.querySelectorAll(".d-feat-scrub-h");
element.forEach((element) => {	
var tl1 = gsap.timeline({
scrollTrigger: {
trigger: element,
start: "top 100%",
end: "bottom 0%",
scrub: true
}
});
tl1
.fromTo(elementH, {
xPercent:0,
}, {
xPercent:-50,
})
;
});
};

/**
 * image reveal left-right
 */
const imgRevealLR = function (container) {
const element = container.querySelectorAll(".d-img-lr");
element.forEach((element) => {	
var tl1 = gsap.timeline({
scrollTrigger: {
trigger: element,
toggleActions: "play none none none",
start: "top 85%"
}
});
tl1
.fromTo(element, {
clipPath: "inset(0% 100% 0% 0%)",
}, {
clipPath: "inset(0% 0% 0% 0%)",
duration: 1.2,
ease: "hopWBDMRNR"
})
;
});
};


// services - industries - border animation
const initRevealBorderIndustries = function (container) {
const elementH = container.querySelectorAll(".d-type-23-2");
const rule1 = CSSRulePlugin.getRule(".d-type-23-2::before");
const rule2 = CSSRulePlugin.getRule(".d-type-23-4::after");
const rule3 = CSSRulePlugin.getRule(".d-type-23-3::before");
const rule4 = CSSRulePlugin.getRule(".d-type-23-5::after");

elementH.forEach((elementH) => {	
var tl1 = gsap.timeline({
scrollTrigger: {
trigger: elementH,
toggleActions: "play none none none",
start: "bottom 90%",
scrub: false
}
});
tl1
.fromTo(rule1, {cssRule: {scaleY: 0}},{duration: 1.2, ease: "expo.out", cssRule: {scaleY: 1,transformOrigin: "top"}}, 0)
.fromTo(rule2, {cssRule: {scaleY: 0}},{duration: 1.2, ease: "expo.out", cssRule: {scaleY: 1,transformOrigin: "bottom"}}, "-=1.05")
.fromTo(rule3, {cssRule: {scaleX: 0}},{duration: 1.2, ease: "expo.out", cssRule: {scaleX: 1,transformOrigin: "left"}}, "-=1.05")
.fromTo(rule4, {cssRule: {scaleX: 0}},{duration: 1.2, ease: "expo.out", cssRule: {scaleX: 1,transformOrigin: "right"}}, "-=1.05")
;
});
};


// about - clients - border animation
const initRevealBorderClients = function (container) {
const elementH = container.querySelectorAll(".d-type-33-2");
const rule1 = CSSRulePlugin.getRule(".d-type-33-2::before");
const rule2 = CSSRulePlugin.getRule(".d-type-33-4::after");
const rule3 = CSSRulePlugin.getRule(".d-type-33-3::before");
const rule4 = CSSRulePlugin.getRule(".d-type-33-5::after");

elementH.forEach((elementH) => {	
var tl1 = gsap.timeline({
scrollTrigger: {
trigger: elementH,
toggleActions: "play none none none",
start: "top 80%",
scrub: false
}
});
tl1
.fromTo(rule1, {cssRule: {scaleY: 0}},{duration: 1.2, ease: "expo.out", cssRule: {scaleY: 1,transformOrigin: "top"}}, 0)
.fromTo(rule2, {cssRule: {scaleY: 0}},{duration: 1.2, ease: "expo.out", cssRule: {scaleY: 1,transformOrigin: "bottom"}}, "-=1.05")
.fromTo(rule3, {cssRule: {scaleX: 0}},{duration: 1.2, ease: "expo.out", cssRule: {scaleX: 1,transformOrigin: "left"}}, "-=1.05")
.fromTo(rule4, {cssRule: {scaleX: 0}},{duration: 1.2, ease: "expo.out", cssRule: {scaleX: 1,transformOrigin: "right"}}, "-=1.05")
;
});
};



///////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////